import {useCallback} from "react";

import {useGuideAudioController} from "@khan/guide-core";
import type {ActionBubble, ChatInputMetadata} from "@khan/guide-types";

export const useSendMessageForActionBubble = (sendChatMessage) => {
    const {isVoiceOn, selectedVoice} = useGuideAudioController();

    return useCallback(
        (actionBubble: ActionBubble) => {
            const metadata: ChatInputMetadata = {
                containsSpeechToTextContent: false,
                guideVoiceDescriptor: isVoiceOn ? selectedVoice : null,
                prepopulatedText:
                    actionBubble.storedLabel || actionBubble.label,
                requestUIType: actionBubble.isDynamic
                    ? "DYNAMIC_ACTION_BUBBLE"
                    : "ACTION_BUBBLE",
                requestWithTextToSpeech: isVoiceOn,
                timeToSubmit: 0,
            };

            sendChatMessage(actionBubble.command, metadata);
        },
        [sendChatMessage, isVoiceOn, selectedVoice],
    );
};
